import { render, staticRenderFns } from "./project-status-badge.vue?vue&type=template&id=29aebe7c&scoped=true&"
import script from "./project-status-badge.vue?vue&type=script&lang=js&"
export * from "./project-status-badge.vue?vue&type=script&lang=js&"
import style0 from "./project-status-badge.vue?vue&type=style&index=0&id=29aebe7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aebe7c",
  null
  
)

export default component.exports